module.exports = __webpack_public_path__ + "static/media/omocestus_viridulus_003_APA.bc40687a.mp3";